export default "__VITE_ASSET__BEl8pAQF__"